<template>
  <v-container>
    <v-row class="justify-center d-flex mt-n16">
      <v-col v-if="!selectedCompany" lg="8" md="8" class="mx-auto">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5 class="text-h5 text-typo font-weight-bold">Check your registration with  NEC Construction</h5>
          </div>
          <div class="d-flex">
            <v-btn
              icon
              outlined
              rounded
              color="transparent"
              width="60px"
              height="60px"
              class="ms-auto me-3 btn-outline-light border-radius-md"
            >

            </v-btn>
            <v-btn
              icon
              outlined
              rounded
              color="transparent"
              width="60px"
              height="60px"
              class="me-3 btn-outline-light border-radius-md"
            >

            </v-btn>
            <v-btn
              icon
              outlined
              rounded
              color="transparent"
              width="60px"
              height="60px"
              class="me-auto btn-outline-light border-radius-md"
            >

            </v-btn>
          </div>
          <div class="mt-2 position-relative text-center">
            <p
              class="
                text-sm
                font-weight-bold
                mb-2
                text-secondary text-border
                d-inline
                z-index-2
                bg-white
                px-3
              "
            >

            </p>
          </div>

          <div class="card-padding pb-4">
            <v-form
                v-model="valid"
                @submit.prevent="Search()"
            >
            <label class="text-xs text-typo font-weight-bolder ms-1">Enter registered company name</label>
            <v-text-field
                :rules="[rules.required]"
                v-model="company_name"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="ABC Investments"
                class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
            >
            </v-text-field>
            <v-btn
                :disabled="!valid"
                elevation="0"
                :ripple="false"
                height="43"
                class="
                      font-weight-bold
                      text-uppercase
                      btn-primary
                      bg-gradient-secondary
                      py-2
                      px-6
                      me-2
                      mt-7
                      mb-2
                      w-100
                    "
                small
                @click="Search()"
            >Search</v-btn
            >
          </v-form>
            <v-card-text class="card-padding text-center" v-if="searched">
              <v-alert
                  close-icon="fas fa-times font-size-root"
                  dismissible
                  icon="ni-like-2"
                  :class="searchResults.length > 0
                      ? 'alert-success'
                      : 'alert-danger'"
                  dark
              >
                <span v-if="searchResults.length > 0" class="text-darker"
                ><strong> Results found </strong></span
                >
                <span v-else class="text--lighten-1"
                ><strong> No Results found </strong></span
                >
              </v-alert>
            </v-card-text>
            <div class="text-left">
              <div class="px-4 pt-6 pb-1">
                <div v-for="company in searchResults" :key="company.id">
                  <v-list-item
                      :key="company.id"
                      class="px-0 py-3 bg-gray-100 border-radius-lg p-6 mb-6"
                  >
                    <v-list-item-content class="pa-6">
                      <div class="d-flex flex-column">
                        <h6 class="mb-3 text-sm text-typo font-weight-bold">
                          {{ company.trading_as }}
                        </h6>
                        <span class="mb-2 text-xs text-body"
                        >Company Address:
                      <span class="text-dark font-weight-bold ms-sm-2">{{
                          company.business_address
                        }}</span></span
                        >
                        <span class="mb-2 text-xs text-body"
                        >Registration Number:
                      <span class="text-dark ms-sm-2 font-weight-bold">{{
                          company.registration_number
                        }}</span></span
                        >
                        <span class="text-xs text-body"
                        >Phone Number(s):
                      <span class="text-dark ms-sm-2 font-weight-bold">{{
                          company.telephone
                        }}</span></span
                        >
                      </div>
                    </v-list-item-content>

                    <v-list-item-content class="py-0 text-end">
                      <div class="pa-4 align-right text-sm text-body">
                        <v-btn
                            :ripple="false"
                            color="success"
                            outlined
                            class="text--lighten-5 font-weight-bolder py-6 px-5 shadow-0"
                            small
                            simple
                            @click="goTo(company)"
                        >
                          <v-icon size="12" class="me-1"
                          >fas fa-check me-1</v-icon
                          >
                          This is my company
                        </v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </div>
            <hr>
            <div class="text-center">
              <p class="text-sm text-body mt-3 mb-0">
                Already have an account?
                <a
                    @click="BackToLogin()"
                    class="
              text-secondary text-gradient text-decoration-none
              font-weight-bold
            "
                >Sign In</a
                >
              </p>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="selectedCompany" lg="8" md="8" class="mx-auto">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <!--            <h5 class="text-h5 text-typo font-weight-bold">Register with NEC-Construction Zimbabwe</h5>-->
            <h5 class="text-h5 text-typo font-weight-bold">Register with NEC Construction</h5>
          </div>
          <div class="d-flex">
            <v-btn
                icon
                outlined
                rounded
                color="transparent"
                width="60px"
                height="60px"
                class="ms-auto me-3 btn-outline-light border-radius-md"
            >

            </v-btn>
            <v-btn
                icon
                outlined
                rounded
                color="transparent"
                width="60px"
                height="60px"
                class="me-3 btn-outline-light border-radius-md"
            >

            </v-btn>
            <v-btn
                icon
                outlined
                rounded
                color="transparent"
                width="60px"
                height="60px"
                class="me-auto btn-outline-light border-radius-md"
            >

            </v-btn>
          </div>
          <div class="mt-2 position-relative text-center">
            <p
                class="
                text-sm
                font-weight-bold
                mb-2
                text-secondary text-border
                d-inline
                z-index-2
                bg-white
                px-3
              "
            >

            </p>
          </div>
          <v-form v-model="valid" @submit.prevent="register">
          <div class="card-padding pb-4">
            <label class="text-xs text-typo font-weight-bolder ms-1">Full name</label>
            <v-text-field
                v-model="fullname"
                :rules="[rules.required]"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="John Doe"
                class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Email address </label>
            <v-text-field
                v-model="email"
                :rules="[rules.required]"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="name@company.co.zw"
                class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
            >
            </v-text-field>

            <label class="text-xs text-typo font-weight-bolder ms-1">Trading name</label>
            <v-text-field
                disabled
                v-model="trading_as"
                :rules="[rules.required]"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="Company XYZ"
                class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
            >
            </v-text-field>

            <v-btn
                :disabled="!valid"
                elevation="0"
                :ripple="false"
                height="43"
                class="
          font-weight-bold
          text-uppercase
          btn-primary
          bg-gradient-secondary
          py-2
          px-6
          me-2
          mt-7
          mb-2
          w-100
        "
                color="#5e72e4"
                small
                @click="Register()"
            >Sign Up</v-btn
            >
            <hr class="mt-3">
            <div class="text-center">
              <p class="text-sm text-body mt-3 mb-0">
                Already have an account ?
                <a
                    @click="BackToLogin()"
                    class="
              text-secondary text-gradient text-decoration-none
              font-weight-bold
            "
                >Sign In</a
                >
              </p>
            </div>
          </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
        v-model="successDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Success
        </v-card-title>

        <v-card-text>
          Your company verification is done. Please check your email {{email}} for the verification password.
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="BackToLogin()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Error
        </v-card-title>

        <v-card-text>
          {{ errorMessage }}
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="danger darken-1"
              text
              outlined
              @click="errorDialog = false"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </div>
  </v-container>

</template>
<script>
import {
  mapState,
} from 'vuex'
import axios from 'axios'
import Alerts from "@/views/Pages/Alerts";
export default {
  name: "sign-up-basic",
  components: {Alerts},
  data() {
    return {
      valid: false,
      searched:false,
      selectedCompany: false,
      files:[],
      selectedID: "",
      fullname: "",
      errorMessage: "",
      company_name: "",
      phone_number: "",
      director_name: "",
      successDialog: false,
      errorDialog: false,
      overlay:false,
      id_number: "",
      email: "",
      username: "",
      firstname: "",
      lastname: "",
      password: "Password123*",
      trading_as: "",
      business_type: "",
      registration_number: "",
      business_address: "",
      director_address: "",
      workshop_address: "",
      trades_performed: "",
      workman_ecnumber: "",
      director_names:"",
      searchResults: [],
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length >= 10 || 'Max 10 characters',
        counter_id: value => value.length >= 11 || 'Max 11 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    };
  },
  computed: {
    ...mapState(['base_url']),
  },
  methods: {
    async Register(){
      this.overlay = true
      let Todaydate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      console.log(Todaydate)
      this.uploadData =
        {
          "firstname": this.fullname,
          "orgID": this.selectedID,
          "director_names": this.director_names,
          "email": this.email,
          "type": "VERIFICATION",
          "username": this.email,
          "id_number": this.email,
          "password": "Password123*",
          "trading_as": this.trading_as,
          "business_address": this.business_address,
        }
      console.log(this.uploadData)
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const JWTToken = this.$store.getters.accessToken
      await axios
          .post( this.base_url + "/auth/register/", this.uploadData)
          .then((response) => {
            console.log(response)
            this.overlay = true;
            if (response.status === 201) {
              console.log(response.data);
              this.successDialog = true
            }
            else if (response.status === 400){
              this.errorMessage = response.data.message
              console.log(this.errorMessage)
              this.overlay = false;
              this.errorDialog = true;
            }
            else {
              this.overlay = false;
              this.errorMessage = response.data.message
              this.errorDialog = true;
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.errorMessage = error.response.data.message
              this.overlay = false;
              this.errorDialog = true;
            } else if (error.response.status === 404) {
              this.overlay = false;
              this.errorMessage = error.response.data.message
              this.errorDialog = true;
            } else if (error.response.status === 500) {
              this.overlay = false;
              this.errorMessage = error.response.data.message
              this.errorDialog = true;
            }else{
              this.overlay = false;
              this.errorDialog = true;
            }
          });

    },
    async Search(){
      this.overlay = true
      this.searchData =
          {
            "company_name": this.company_name,
            "director_name": this.director_name,
            "phone_number": this.phone_number
          }
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const JWTToken = this.$store.getters.accessToken
      await axios
          .post( this.base_url + "/auth/search-companies/", this.searchData)
          .then((response) => {
            console.log(response)
            if (response.status === 200) {
              this.searched = true
              this.searchResults = response.data
              this.overlay = false;
            } else if (response.status === 204){
              this.searchResults = []
              this.searched = true;
              this.overlay = false;
            }
            else {
              this.searched = true;
              this.overlay = false;
              this.errorUpload = true;
              console.log(response)
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.overlay = false;
              this.errorUpload = true;
            } else if (error.response.status === 404) {
              this.overlay = false;
              this.errorUpload = true;
            } else if (error.response.status === 500) {
              this.errorMessage = "Organisation account already exists"
              this.overlay = false;
              this.errorUpload = true;
            }else{
              this.overlay = false;
              this.errorUpload = true;
            }
          });

    },
    goTo(val){
      console.log(val)
      this.selectedCompany = true
      this.selectedID = val.id
      this.email = val.email
      this.business_address = val.business_address
      this.trading_as = val.trading_as
      this.fullname = val.contact_name
    },

    BackToLogin(){
      this.$router.push("/login").catch(() => {})
    },

  },
};
</script>
